// ** React Imports
import {ChangeEvent, useState} from 'react'

// ** MUI Components
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'

// ** Icon Imports
import Icon from 'src/@core/components/icon'
import {useFormContext} from "react-hook-form";
import {ControlledTextField} from "../../../../components/forms";
import {SignupFields} from "../../../../types/user/authData";

export interface State {
    showPassword: boolean,
    showConfirmPassword: boolean
}

const StepCredentialsInfo = ({ handlePrev }: { [key: string]: () => void }) => {

    const [values, setValues] = useState<State>({
        showPassword: false,
        showConfirmPassword: false
    })
    const [repeatMail, setRepeatMail] = useState('')
    const methods = useFormContext()
    const watchMail = methods.watch(SignupFields.Email)
    const watchPassword = methods.watch(SignupFields.Password)

    const handleClickShowPassword = () => {
        setValues({...values, showPassword: !values.showPassword})
    }
    const handleClickShowConfirmPassword = () => {
        setValues({...values, showConfirmPassword: !values.showConfirmPassword})
    }

    const [isValid, setIsValid] = useState<boolean>(true);
    const [repeatValid, setRepeatValid] = useState<boolean>(false)
    const [validPassword, setValidPassword] = useState<boolean>(false)
    const [passwordRepeat, setPasswordRepeat] = useState<string>('')

    const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newEmail = event.target.value;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        const isValidEmail = emailRegex.test(newEmail);

        setIsValid(isValidEmail);
        methods.setValue(SignupFields.Email, newEmail);
    };

    const handleChangeRepeatEmail = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        if (watchMail && watchMail !== value && watchMail === repeatMail) {
            methods.setValue(SignupFields.Email, '');
        }

        setRepeatMail(value);
        setRepeatValid(value === watchMail);
    };

    const handleChangeConfirmPassword = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value

        value !== watchPassword ? setValidPassword(false) : setValidPassword(true)
        setPasswordRepeat(value)
    }

    return (
        <>
            <Box sx={{ mb: 4 }}>
                <Typography variant='h5'>Datos de inicio de sesión del solicitante</Typography>
                <Typography sx={{ color: 'text.secondary' }}>Verifique los datos a ingresar antes de continuar</Typography>
            </Box>

            <Grid container spacing={5}>
                <Grid item xs={12} sm={6}>
                    <ControlledTextField
                        name={SignupFields.Email}
                        label='Email'
                        control={methods.control}
                        fullWidth
                        onChange={handleEmailChange}
                        error={!isValid}
                        helperText={!isValid ? "El formato del correo electrónico es inválido" : ""}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <ControlledTextField control={methods.control}
                                         label={'Repetir Mail'}
                                         value={repeatMail}
                                         fullWidth
                                         onChange={handleChangeRepeatEmail}
                                         error={!repeatValid}
                                         helperText={!repeatValid ? "Los correos no coinciden" : ""}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <ControlledTextField control={methods.control}
                                         label={'Contraseña'}
                                         name={SignupFields.Password}
                                         id='input-password'
                                         fullWidth
                                         type={values.showPassword ? 'text' : 'password'}
                                         InputProps={{
                                             endAdornment: 
                                             <InputAdornment position='end'>
                                                 <IconButton edge='end' onMouseDown={e => e.preventDefault()} onClick={handleClickShowPassword}>
                                                    <Icon icon={values.showPassword ? 'mdi:eye-outline' : 'mdi:eye-off-outline'} />
                                                 </IconButton>
                                             </InputAdornment>
                                         
                                         }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <ControlledTextField control={methods.control}
                                         label={'Confirmá tu contraseña'}
                                         id='input-confirm-password'
                                         fullWidth
                                         value={passwordRepeat}
                                         type={values.showConfirmPassword ? 'text' : 'password'}
                                         InputProps={{
                                             endAdornment:
                                                 <InputAdornment position='end'>
                                                     <IconButton edge='end' onMouseDown={e => e.preventDefault()} onClick={handleClickShowConfirmPassword}>
                                                         <Icon icon={values.showConfirmPassword ? 'mdi:eye-outline' : 'mdi:eye-off-outline'} />
                                                     </IconButton>
                                                 </InputAdornment>

                                         }}
                                         disabled={!watchPassword}
                                         onChange={handleChangeConfirmPassword}
                                         error={!validPassword}
                                         helperText={!validPassword ? 'Las contraseñas no coinciden' : ''}
                    />
                </Grid>
                
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button color='secondary' variant='contained' onClick={handlePrev} startIcon={<Icon icon='mdi:chevron-left' fontSize={20} />}>
                            Atrás
                        </Button>
                        <Button variant='contained'
                                color='success'
                                type='submit'
                                endIcon={<Icon icon='mdi:chevron-right' fontSize={20} />}
                                disabled={!repeatValid || !validPassword}
                        >
                            Finalizar
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

export default StepCredentialsInfo
